var React = require('react');

function SliderArrowLeftBlack (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M82 21H2","stroke":"#101010","strokeWidth":"1.4","key":0}),React.createElement("path",{"d":"M23.5 41L2 21L23.5 1","stroke":"#101010","strokeWidth":"1.4","key":1})]);
}

SliderArrowLeftBlack.defaultProps = {"width":"82","height":"42","viewBox":"0 0 82 42","fill":"none"};

module.exports = SliderArrowLeftBlack;

SliderArrowLeftBlack.default = SliderArrowLeftBlack;
